/* fleet-data.js — taxonomy + local draft defaults only.
   Soft≠Live: no Soft campaign / firmware / KPI / DIAG catalogues.
   Live rows come from OTA + ops metrics buses; empty means empty. */

/* ── firmware taxonomy (not Live rows) ────────────────────────────────── */

export const CAMPAIGN_STATES = [
  { id:"dispatched",  t:"Dispatched",  chip:"warn" },
  { id:"running",     t:"Running",     chip:"" },
  { id:"success",     t:"Success",     chip:"" },
  { id:"partial",     t:"Partial",     chip:"warn" },
  { id:"failed",      t:"Failed",      chip:"bad" },
  { id:"rolled_back", t:"Rolled back", chip:"bad" },
  { id:"cancelled",   t:"Cancelled",   chip:"off" },
];

export const RUN_STATES = ["pending","dispatched","success","failed","rolled_back"];

/* Per-campaign Soft stall editor removed — Live ack timeout is GET /ota/policy. */
export const STALL_DEFAULT = { min:30, act:"leave" };

export const STALL_ACTIONS = [
  { id:"leave", t:"Leave it running",    say:"The run stays open and keeps waiting." },
  { id:"fail",  t:"Mark the run failed", say:"The run closes as failed and the campaign recomputes." },
  { id:"retry", t:"Retry once",          say:"Send the command again, one time only." },
];

export const ROLLBACK_DEFAULT = { on:true, at:1 };

/* Soft OTA_FLAGS toggles removed from Fleet Firmware — Live policy readout only. */
export const OTA_FLAGS = [
  { k:"campaign_write", t:"Campaign writes", on:true,
    say:"Publish, accept, decline and roll back." },
  { k:"campaign_read",  t:"Campaign reads",  on:true,
    say:"Listing and campaign detail." },
  { k:"sku_match",      t:"Hardware match",  on:true,
    say:"Refuse a build whose hardware code does not match the device." },
  { k:"step_up",        t:"Second factor on writes", on:false,
    say:"Re-authenticate before publish, accept or roll back." },
];

/* ── offline attribution taxonomy ─────────────────────────────────────── */

export const BUCKETS = [
  { id:"B0", t:"Stale, cause unclear", say:"The row aged out and nothing else explains it.",
    act:"Check the device's own uplink before assuming the platform." },
  { id:"B1", t:"Ghost — telemetry suppressed", say:"The device is publishing but the platform is deliberately ignoring it.",
    act:"The unit is claimed elsewhere, or was reclaimed. Settle custody first." },
  { id:"B2", t:"Broker refused it", say:"The connection is being rejected at the broker.",
    act:"Compare the device's credentials and access rules against what the platform issued." },
  { id:"B3", t:"No state row at all", say:"Nothing has ever arrived from this device.",
    act:"It was claimed but never reached the broker. Start at power and network." },
  { id:"B4", t:"Heartbeat slower than the window", say:"Its interval is longer than the offline threshold, so it is offline between beats.",
    act:"Either shorten the interval on the device or widen the threshold. Do not do both." },
  { id:"B5", t:"Retained last-will", say:"The broker still holds an offline notice and no newer frame has overruled it.",
    act:"Usually clears itself on the next heartbeat. If it persists the session never re-established." },
  { id:"B6", t:"Cache or console lag", say:"The underlying data is fine and the view is behind.",
    act:"Wait one cache cycle before escalating anything." },
  { id:"B7", t:"Boot sync or cloud unreachable", say:"It booted but could not complete its first call home.",
    act:"Check outbound reachability from where the device sits." },
];

export const REASONS = [
  ["Newer signal arrived","Something the device sent after its status report proves it is alive."],
  ["Check-in beat the notice","The device checked in after the broker announced it had dropped, so the check-in wins."],
  ["No timestamps yet","Nothing it has sent carries a time, so it is judged on content alone."],
  ["Only an offline notice","The one thing on record is the notice the broker sends when a device drops."],
  ["Only a status report","There is nothing but the device's own status report to go on."],
];
